import { isInWebView } from './GeorgeGoService';
import { getSuccessUrl } from './successUrlService';

export const quitWebView = (): boolean => {
    if (!isInWebView()) {
        return false;
    }

    const successUrl = getSuccessUrl();

    if (!successUrl) {
        return false;
    }

    window.location.href = successUrl;

    return true;
};
